import { render, staticRenderFns } from "./OrangeGradationButton.vue?vue&type=template&id=0f0e30c6&scoped=true&"
import script from "./OrangeGradationButton.vue?vue&type=script&lang=js&"
export * from "./OrangeGradationButton.vue?vue&type=script&lang=js&"
import style0 from "./OrangeGradationButton.vue?vue&type=style&index=0&id=0f0e30c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0e30c6",
  null
  
)

export default component.exports